import { render, staticRenderFns } from "./InstagramChannels.vue?vue&type=template&id=38ad733c&scoped=true"
import script from "./InstagramChannels.vue?vue&type=script&lang=js"
export * from "./InstagramChannels.vue?vue&type=script&lang=js"
import style0 from "./InstagramChannels.vue?vue&type=style&index=0&id=38ad733c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ad733c",
  null
  
)

export default component.exports